import initialState from './initialState'

/**
 * @description
 * set status, token, user and hasLoadedOnce after success user login
 *
 * @param {object} state
 * @return {void}
 */
const authSuccess = (state, token) => {
    state.status = 'success'
    state.token = token
    state.user = JSON.parse(localStorage.getItem('user'))
    state.cash_desk_token = localStorage.getItem('cash_desk_token') || ''
    state.hasLoadedOnce = true
}

/**
 * @description
 *
 * set token to void after user logout
 * @param {Object} state
 * @return {void}
 */
const authLogout = state => {
    state.token = ''
    state.user = ''
    state.cash_desk_token = ''
}

const SET_OPEN_CASH_DESK = (state, boolean) => {
    state.openCashDesk = boolean
}

const SET_MUST_CLOSE_CASH_DESK = (state, boolean) => {
    state.mustCloseCashDesk = boolean
}

/**
 * @description
 *
 * Returns State to it's initial values
 * @param {*} state
 */
const resetState = state => {
    Object.assign(state, initialState())
}

const SET_CASH_DESK_ID = (state, id) => {
    state.cash_desk_id = id
}

const SET_TBK = (state, tbk) => (state.tbk = tbk)

const SET_CASH_DESK_TOKEN = (state, token) => (state.cash_desk_token = token)

export default {
    authSuccess,
    authLogout,
    resetState,
    SET_OPEN_CASH_DESK,
    SET_TBK,
    SET_CASH_DESK_ID,
    SET_CASH_DESK_TOKEN,
    SET_MUST_CLOSE_CASH_DESK,
}
